import { gql } from "@apollo/client";

const SAVE_VISITA_TELE_ENFERMERIA_AE = gql`
    mutation saveVisitaTeleEnfermeriaAE($input: AddVisitaTeleEnfermeriaAEInput!){
        saveVisitaTeleEnfermeriaAE(input: $input) {
            idTeleEnfermeriaAE
            idVisita
        }
    }
`;

export default SAVE_VISITA_TELE_ENFERMERIA_AE;

export const adaptAddVisitaTeleEnfermeriaAEInput = (data) => ({
  idTeleEnfermeriaAE: data?.idTeleEnfermeriaAE,
  accesoDescripcion: data?.accesoDescripcion,
  notaAlteracion: data?.notaAlteracion,
  supuracion: !!data?.supuracion,
  eritemas: !!data?.eritemas,
  granulomasFuga: !!data?.granulomasFuga,
  resistenciaPermeabilidad: !!data?.resistenciaPermeabilidad,
  formaLavadoAcceso: data?.formaLavadoAcceso,
  frecLavadoAcceso: data?.frecLavadoAcceso,
  estaPermeable: !!data?.estaPermeable,
  fijacionDescripcionAE: data?.fijacionDescripcionAE,
  marcaReferenciaDespla: data?.marcaReferenciaDespla,
  seDesplazo: !!data?.seDesplazo,
  accionSiDesplazo: data?.accionSiDesplazo,
  fechaUltimoCambioSonda: data?.fechaUltimoCambioSonda,
  quienCambioSonda: data?.quienCambioSonda,
  idMetodoAdministracion: data?.idMetodoAdministracion,
  observacionGeneral: data?.observacionGeneral,
  idBombaInfusion: data?.idBombaInfusion,
  estaEnchufada: !!data?.estaEnchufada,
  funcionamientoAdecuado: !!data?.funcionamientoAdecuado,
  remanenteBolsa: data?.remanenteBolsa || '',
  mantenimientoBomba: data?.mantenimientoBomba || '',
  alarmasSuenan: !!data?.alarmasSuenan,
  modeloBomba: data?.modeloBomba || '',
  reemplazoBomba: data?.reemplazoBomba || '',
  velocidadAdministraForm: data?.velocidadAdministraForm || '',
  idVisita: data?.idVisita
});